var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pajamas:twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.2942 6.928L14.3572 1H13.1572L8.7622 6.147L5.2502 1H1.2002L6.5102 8.784L1.2002 15H2.4002L7.0422 9.564L10.7512 15H14.8012L9.2942 6.928ZM7.6512 8.852L7.1132 8.077L2.8322 1.91H4.6752L8.1292 6.887L8.6672 7.662L13.1582 14.132H11.3152L7.6512 8.852Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIco);
export default __webpack_public_path__ + "static/media/x-ico.05c93d2162789e96d0bcd1c10fcbd0ec.svg";
export { ForwardRef as ReactComponent };